const dictionary = {
  "en": {
    navHome: "home",
    navFavourites: "favourites",
    navSearch: "search",
    searchPlaceholder: "Search",
    settings: "Settings",
    contributors: "Contributors",
    logout: "Logout",
    settingsTitle: "Settings",
    settingsSubtitle: "Manage your profile, visual identity and regional preferences.",
    profile: "Profile",
    displayName: "Display name",
    publicName: "Your public name",
    profileImageUrl: "Profile image URL",
    siteLanguage: "Site language",
    contentCountry: "Content country",
    useBrowserLocale: "Use browser locale",
    saveProfile: "Save profile",
    password: "Password",
    currentPassword: "Current password",
    currentPasswordPlaceholder: "Enter your current password",
    newPassword: "New password",
    newPasswordPlaceholder: "Enter a new password",
    confirmNewPassword: "Confirm new password",
    confirmNewPasswordPlaceholder: "Repeat the new password",
    updatePassword: "Update password",
    loginTitle: "To continue, log in to Kiritofy.",
    loginButton: "Login",
    emailAddress: "Email address",
    passwordLabel: "Password",
    noAccount: "Don't have an account?",
    signupRedirect: "Sign up for Kiritofy",
    signupTitle: "Sign up for free to start listening.",
    signupButton: "Sign up",
    signupHaveAccount: "Have an account?",
    signupLogin: "Log in",
    signupEmail: "What's your email?",
    signupEmailPlaceholder: "Enter your email.",
    confirmEmail: "Confirm your email",
    confirmEmailPlaceholder: "Enter your email again.",
    createPassword: "Create a password",
    createPasswordPlaceholder: "Enter a password.",
    profileNameQuestion: "What should we call you?",
    profileNamePlaceholder: "Enter a profile name.",
    profileNameHint: "This appears on your profile.",
    yourLibrary: "Your library",
listenAgain: "Listen again",
    profileImageUpdated: "Profile image updated",
    profileImageError: "Error uploading profile image",
    noDataFound: "No data found.",
    unknownArtist: "Unknown Artist",
    noResultsFound: "No results found.",
    navSongs: "Songs",
    navAlbums: "Albums",
    navPlaylists: "Playlists",
    navArtists: "Artists",
    loading: "Loading...",
    addingToFavourites: "Adding to Favourites.",
    addedToFavourites: "Added to Favourites.",
    removingFromFavourites: "Removing from Favourites.",
    removedFromFavourites: "Removed from Favourites.",
    favouritesRequestFailed: "Favourites request failed.",
    upNext: "Up next",
    related: "Related",
    lyrics: "Lyrics",
    removeFromFavourites: "Remove from Favourites?",
    remove: "Remove",
    upNextListEmpty: "Up next list is empty.",
    fixList: "Fix list",
    songWillPlayNext: "Song will play next",
    playlistWillPlayNext: "Playlist will play next",
    cancel: "Cancel",
    shufflePlay: "Shuffle play",
    startRadio: "Start radio",
    playNext: "Play next",
    addToQueue: "Add to queue",
    goToAlbum: "Go to album",
    goToArtist: "Go to artist",
    songAddedToQueue: "Song added to queue",
    playlistAddedToQueue: "Playlist added to queue",
    loginSuccess: "Login successfully.",
    signupSuccess: "Account created successfully.",
    genericError: "Oops! Something went wrong. Please try again",
    emailEmpty: "Please enter your Kiritofy email address",
    emailInvalid: "This email is invalid.",
    passwordEmpty: "Please enter your password.",
    passwordShort: "Your password is too short.",
    signupEmailEmpty: "You need to enter your email.",
    signupEmailInvalid: "This email is invalid. Make sure it's written like example@email.com",
    signupConfirmEmailEmpty: "You need to confirm your email.",
    signupEmailsNotMatch: "The email addresses don't match.",
    signupPasswordEmpty: "You need to enter a password.",
    signupProfileNameEmpty: "Enter a name for your profile.",
  },
  "pt": {
    navHome: "início",
    navFavourites: "favoritos",
    navSearch: "buscar",
    searchPlaceholder: "Buscar",
    settings: "Configurações",
    contributors: "Colaboradores",
    logout: "Sair",
    settingsTitle: "Configurações",
    settingsSubtitle: "Gerencie seu perfil, identidade visual e preferências regionais.",
    profile: "Perfil",
    displayName: "Nome de exibição",
    publicName: "Seu nome público",
    profileImageUrl: "URL da foto do perfil",
    siteLanguage: "Idioma do site",
    contentCountry: "País do conteúdo",
    useBrowserLocale: "Usar local do navegador",
    saveProfile: "Salvar perfil",
    password: "Senha",
    currentPassword: "Senha atual",
    currentPasswordPlaceholder: "Digite sua senha atual",
    newPassword: "Nova senha",
    newPasswordPlaceholder: "Digite uma nova senha",
    confirmNewPassword: "Confirmar nova senha",
    confirmNewPasswordPlaceholder: "Repita a nova senha",
    updatePassword: "Atualizar senha",
    loginTitle: "Para continuar, faça login no Kiritofy.",
    loginButton: "Entrar",
    emailAddress: "Endereço de email",
    passwordLabel: "Senha",
    noAccount: "Não tem uma conta?",
    signupRedirect: "Criar conta no Kiritofy",
    signupTitle: "Cadastre-se grátis para começar a ouvir.",
    signupButton: "Cadastrar",
    signupHaveAccount: "Já tem uma conta?",
    signupLogin: "Entrar",
    signupEmail: "Qual é o seu email?",
    signupEmailPlaceholder: "Digite seu email.",
    confirmEmail: "Confirme seu email",
    confirmEmailPlaceholder: "Digite seu email novamente.",
    createPassword: "Crie uma senha",
    createPasswordPlaceholder: "Digite uma senha.",
    profileNameQuestion: "Como devemos te chamar?",
    profileNamePlaceholder: "Digite um nome de perfil.",
    profileNameHint: "Isso aparecerá no seu perfil.",
    yourLibrary: "Sua biblioteca",
    listenAgain: "Ouvir de novo",
    profileImageUpdated: "Foto de perfil atualizada",
    profileImageError: "Erro ao carregar foto de perfil",
    noDataFound: "Nenhum dado encontrado.",
    unknownArtist: "Artista Desconhecido",
    noResultsFound: "Nenhum resultado encontrado.",
    navSongs: "Músicas",
    navAlbums: "Álbuns",
    navPlaylists: "Playlists",
    navArtists: "Artistas",
    loading: "Carregando...",
    addingToFavourites: "Adicionando aos favoritos.",
    addedToFavourites: "Adicionado aos favoritos.",
    removingFromFavourites: "Removendo dos favoritos.",
    removedFromFavourites: "Removido dos favoritos.",
    favouritesRequestFailed: "Falha na solicitação de favoritos.",
    upNext: "A seguir",
    related: "Relacionados",
    lyrics: "Letras",
    removeFromFavourites: "Remover dos favoritos?",
    remove: "Remover",
    upNextListEmpty: "A lista de próximas músicas está vazia.",
    fixList: "Corrigir lista",
    songWillPlayNext: "A música tocará em seguida",
    playlistWillPlayNext: "A playlist tocará em seguida",
    cancel: "Cancelar",
    shufflePlay: "Tocar aleatoriamente",
    startRadio: "Iniciar rádio",
    playNext: "Tocar a seguir",
    addToQueue: "Adicionar à fila",
    goToAlbum: "Ir para o álbum",
    goToArtist: "Ir para o artista",
    songAddedToQueue: "Música adicionada à fila",
    playlistAddedToQueue: "Playlist adicionada à fila",
    loginSuccess: "Login realizado com sucesso.",
    signupSuccess: "Conta criada com sucesso.",
    genericError: "Ops! Algo deu errado. Por favor, tente novamente",
    emailEmpty: "Por favor, insira seu e-mail do Kiritofy",
    emailInvalid: "Este e-mail é inválido.",
    passwordEmpty: "Por favor, insira sua senha.",
    passwordShort: "Sua senha é muito curta.",
    signupEmailEmpty: "Você precisa inserir seu e-mail.",
    signupEmailInvalid: "Este e-mail é inválido. Certifique-se de que esteja escrito como exemplo@email.com",
    signupConfirmEmailEmpty: "Você precisa confirmar seu e-mail.",
    signupEmailsNotMatch: "Os e-mails não coincidem.",
    signupPasswordEmpty: "Você precisa inserir uma senha.",
    signupProfileNameEmpty: "Insira um nome para o seu perfil.",
  },
  "es": {
    navHome: "inicio",
    navFavourites: "favoritos",
    navSearch: "buscar",
    searchPlaceholder: "Buscar",
    settings: "Configuracion",
    contributors: "Colaboradores",
    logout: "Salir",
    settingsTitle: "Configuracion",
    settingsSubtitle: "Administra tu perfil, identidad visual y preferencias regionales.",
    profile: "Perfil",
    displayName: "Nombre visible",
    publicName: "Tu nombre publico",
    profileImageUrl: "URL de la foto de perfil",
    siteLanguage: "Idioma del sitio",
    contentCountry: "Pais del contenido",
    useBrowserLocale: "Usar idioma del navegador",
    saveProfile: "Guardar perfil",
    password: "Contrasena",
    currentPassword: "Contrasena actual",
    currentPasswordPlaceholder: "Escribe tu contrasena actual",
    newPassword: "Nueva contrasena",
    newPasswordPlaceholder: "Escribe una nueva contrasena",
    confirmNewPassword: "Confirmar nueva contrasena",
    confirmNewPasswordPlaceholder: "Repite la nueva contrasena",
    updatePassword: "Actualizar contrasena",
    loginTitle: "Para continuar, inicia sesion en Kiritofy.",
    loginButton: "Entrar",
    emailAddress: "Correo electronico",
    passwordLabel: "Contrasena",
    noAccount: "No tienes una cuenta?",
    signupRedirect: "Crear cuenta en Kiritofy",
    signupTitle: "Registrate gratis para empezar a escuchar.",
    signupButton: "Registrarse",
    signupHaveAccount: "Ya tienes una cuenta?",
    signupLogin: "Entrar",
    signupEmail: "Cual es tu correo?",
    signupEmailPlaceholder: "Escribe tu correo.",
    confirmEmail: "Confirma tu correo",
    confirmEmailPlaceholder: "Escribe tu correo otra vez.",
    createPassword: "Crea una contrasena",
    createPasswordPlaceholder: "Escribe una contrasena.",
    profileNameQuestion: "Como quieres que te llamemos?",
    profileNamePlaceholder: "Escribe un nombre de perfil.",
    profileNameHint: "Esto aparecera en tu perfil.",
    yourLibrary: "Tu biblioteca",
    listenAgain: "Escuchar de nuevo",
    profileImageUpdated: "Imagen de perfil actualizada",
    profileImageError: "Error al cargar imagen de perfil",
    noDataFound: "No se encontraron datos.",
    unknownArtist: "Artista Desconocido",
    noResultsFound: "No se encontraron resultados.",
    navSongs: "Canciones",
    navAlbums: "Álbumes",
    navPlaylists: "Listas",
    navArtists: "Artistas",
    loading: "Cargando...",
    addingToFavourites: "Agregando a favoritos.",
    addedToFavourites: "Agregado a favoritos.",
    removingFromFavourites: "Eliminando de favoritos.",
    removedFromFavourites: "Eliminado de favoritos.",
    favouritesRequestFailed: "Error en la solicitud de favoritos.",
    upNext: "A continuación",
    related: "Relacionados",
    lyrics: "Letras",
    removeFromFavourites: "Eliminar de favoritos?",
    remove: "Eliminar",
    upNextListEmpty: "La lista de siguientes está vacía.",
    fixList: "Corregir lista",
    songWillPlayNext: "La canción se reproducirá a continuación",
    playlistWillPlayNext: "La lista se reproducirá a continuación",
    cancel: "Cancelar",
    shufflePlay: "Reproducción aleatoria",
    startRadio: "Iniciar radio",
    playNext: "Reproducir a continuación",
    addToQueue: "Agregar a la cola",
    goToAlbum: "Ir al álbum",
    goToArtist: "Ir al artista",
    songAddedToQueue: "Canción agregada a la cola",
    playlistAddedToQueue: "Lista agregada a la cola",
    loginSuccess: "Inicio de sesión exitoso.",
    signupSuccess: "Cuenta creada con éxito.",
    genericError: "¡Ups! Algo salió mal. Por favor, inténtalo de nuevo",
    emailEmpty: "Por favor, introduce tu correo de Kiritofy",
    emailInvalid: "Este correo no es válido.",
    passwordEmpty: "Por favor, introduce tu contraseña.",
    passwordShort: "Tu contraseña es demasiado corta.",
    signupEmailEmpty: "Debes introducir tu correo.",
    signupEmailInvalid: "Este correo no es válido. Asegúrate de que esté escrito como ejemplo@email.com",
    signupConfirmEmailEmpty: "Debes confirmar tu correo.",
    signupEmailsNotMatch: "Los correos electrónicos no coinciden.",
    signupPasswordEmpty: "Debes introducir una contraseña.",
    signupProfileNameEmpty: "Introduce un nombre para tu perfil.",
  },
};

export const getLanguageGroup = language => {
  const normalized = String(language || "en").toLowerCase();
  if (normalized.startsWith("pt")) return "pt";
  if (normalized.startsWith("es")) return "es";
  return "en";
};

export const t = (language, key) => {
  const group = getLanguageGroup(language);
  return dictionary[group]?.[key] || dictionary.en[key] || key;
};

